import React from 'react';
import { Button } from 'nike-ui/src/components/button/Button';

import i18n from '@i18n';
import ReclamationIcon from '@/icons/ReclamationIcon';
import PopupNg from '@/ui/PopupNg';
import { REKLAMACIA } from '@/routing/routes';
import { navigate } from '@/routing';

function Claim({ hash }) {
    function onClick() {
        PopupNg.dispatcher.close('ticketDetail');
        navigate(REKLAMACIA, { hash });
        PopupNg.dispatcher.close('betbook/ticketDetailPopup');
    }

    return (
        <Button
            className="blue"
            dataAtid="ticket-detail-reclamation"
            icon={ReclamationIcon}
            label={i18n('tiket.detailTiketu.reklamacia.textlinky')}
            onClick={onClick}
        />
    );
}

export default Claim;
